import React, {useState, useEffect} from 'react';
import '../main-css/MainContent.css';
import { Link } from 'react-router-dom';
import NewsWidget from './news-js/NewsWidget.js';
import LoginPopUp from './login-js/LoginPopUp.js';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_PROD_URL;

const MainContent = () => {
  //Login Pop Up
  const [isModalOpen, setModalOpen] = useState(false);
  const [user, setUser] = useState(null);

  const handleSignInClick = () =>{
    setModalOpen(!isModalOpen);  
  };

  const fetchProfile = async () => {    
    try {
        console.log('Attempting to fetch profile...');
        
        const response = await fetch(`${BACKEND_URL}/valid/profile`, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        });

        console.log('Profile fetch response status:', response.status);
        
        if (response.status === 401) {
            console.log('Unauthorized - attempting token refresh');
            const refreshResponse = await fetch(`${BACKEND_URL}/valid/refresh-token`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' }
            });

            if (!refreshResponse.ok) {
                console.log('Token refresh failed');
                setUser(null);
                return;
            }
        }

        if (!response.ok) {
            console.warn('Profile fetch failed:', response.status);
            setUser(null);
            return;
        }

        const data = await response.json();
        console.log('Profile data received:', data);
        setUser(data.user);           
    } catch (error) {
        console.error('Error fetching profile:', error);
        setUser(null);
    } 
  };

  useEffect(() => {
    fetchProfile();
  }, []);
  

  return (
    <div className="main-wrapper">
      <header className="header"></header>
      <div className="title">
        <img src="/Images/AnimeBibleLogoTP.png" alt="Anime Logo" className="title-img" />
        ANIMEBIBLE
      </div>
      <div className="content-wrapper">
        <div className="main-content">
          <h1 className="tagline">
            PURE ANIME <br />
            CONVERSATIONS
          </h1>
          <p className="subtitle">DIVE INTO ANIME - YOUR CHAT, YOUR UNIVERSE.</p>
          <div className="buttons">
            <Link to="/chat" onClick={() => console.log('Chat Now button clicked')}>
              <button className="chat-now">Chat Now</button>
            </Link>
            <button className="sign-in" onClick={handleSignInClick}>
              {user ?  `${user.username.charAt(0).toUpperCase()}${user.username.slice(1)}`:'Sign In'}
            </button>
            {isModalOpen && <LoginPopUp onClose={() => setModalOpen(false)}/>}
          </div>
        </div>
        <div className="news-widget">
          <NewsWidget />
        </div>
      </div>
      <div className="hidden-seo-text">
        <p>
          Looking for anime recommendations? AnimeBible helps you discover new anime based on your taste. Our AI-powered chatbot provides personalized suggestions, trending anime, and more!
        </p>
      </div>
    </div>
  );
};

export default MainContent;
